import { useEffect, useState } from "react";
import React from "react";
import { Button, Modal } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { connect } from "react-redux";
import { WMSSelect } from "../../../widgets/selectbox";
import { WMSInput } from "../../../widgets/input";
import { TableLineLoader } from "../../../widgets/tableloader";
// import { taskColumn } from "../../widgets/tableColumn";
import "./index.scss";
import {
  toastError,
  toastSuccess,
  toastWarning,
} from "../../../widgets/toaster";
import { apiUrl } from "../../../base/utils";
import WHSLoader from "../../../widgets/loader";
import { invokeGetService, invokePostService } from "../../../service";
import { dispatchStepAction, dispatchFileUpload } from "../../../redux/action";
import CustomTable from "../../table/customTable";
import { createColumnHelper } from "@tanstack/table-core";
import HOCAutoLogout from "../../autologout";
import moment from "moment";
import wordicon from "../../../images/word-img.png";
import wordImg from "../../../images/word-img.png";
import acceptImg from "../../../images/accept.png";
import rejectImg from "../../../images/reject.png";
import reviseImg from "../../../images/revise.png";
import MultiSelect, { Option } from "../../../widgets/multiselect/multiselect";
import { WMSTextArea } from "../../../widgets/textarea";
import { config } from "../../../config";
import axios from "axios";

const columnHelper = createColumnHelper();
interface Row {
  getValue: () => any;
  row: any;
}
interface DownloadProgress {
  [articleId: string]: boolean;
}
const iconsData = [
  { icon: acceptImg, description: "Accept", subtext: "", type: "accept" },
  { icon: reviseImg, description: "Revise (Minor)", subtext: "Minor changes" },
  { icon: reviseImg, description: "Revise (Major)", subtext: "Major changes" },
  { icon: rejectImg, description: "Reject", subtext: "", type: "reject" },
];
function LangEDManuscript(props: any) {
  const [isTableLoader] = useState(false);
  // const [columns, setColumns] = useState(taskColumn);
  const [tableData, setTableData] = useState([]);
  const [initialData, setInitialData] = useState([]);
  const [wordDownloadData, setWordDownloadData] = useState([]);
  const [selectfileterData, setselectfileterData] = useState([]);
  const [articleDetails, setArticlerowdata] = useState<{
    articleid?: string;
    userid?: string;
    reviewerarticleguid?: string;
  }>({});
  // const [pagination, setPagination] = useState({ startIndex: 0, endIndex: 5 });
  const [message, setMessageContent] = useState("");
  const [downloadData, setdownloadData] = useState("");

  const [suggestion, setsuggestion] = useState("");
  const [messageuggestion, setMessageuggestionContent] = useState("");
  const [combinedText, setCombinedText] = useState("");

  const [constentId, setContentId] = useState(0);
  const [stageDropdown, setStageDropdown] = useState([]);
  const [currentlyDropdown, setCurrentlyDropdown] = useState([]);
  const [showAcceptReject, setShowAcceptReject] = useState<{
    [key: string]: boolean;
  }>({});
  const [isModalshow, setisModalshow] = useState(false);
  const [isAcceptModalshow, setisAcceptModalshow] = useState(false);
  const [isDeclineModalshow, setisDeclineModalshow] = useState(false);
  const [confirmationStatus, setConfirmationStatus] = useState("");
  const [declineconfirmationStatus, setdeclineconfirmationStatus] =
    useState("");
  const [isMultipleGroups, setIsMultipleGroups] = useState(false);
  const [filesize, setFilesize] = useState("");
  const [openHistoryModal, setOpenHistoryModal] = useState(false);
  const [action, setAction] = useState("");

  const [openMsgModal, setOpenMsgModal] = useState(false);
  const [openRecommendModal, setOpenRecommendModal] = useState(false);
  const [fileTipShow, setFileTipShow] = useState(false);
  const [fileerror, setExtention] = useState("");
  const [articlerowdata, setRowData] = useState<any>("");
  const [fileList, setFileList] = useState<any>([]);
  const fileInputRef = React.useRef<HTMLInputElement | null>(null);
  const [selectedOption, setSelectedOption] = useState("sendToAuthor");
  const [reason, setReason] = useState("");
  const [stageValue, setStageValue] = useState({
    label: "All Status",
    value: "All Status",
  });
  // const [statusValue, setStatusValue] = useState('All Status');
  const [currentlywithValue, setCurrentlyValue] = useState({
    label: "All Users",
    value: "Currently with All",
  });
  const [fileName, setFileName] = useState("");
  const [fileData, setFileData] = useState("");
  const [render, setRender] = useState(false);
  const [searchData, setSearchData] = useState("");
  const [isMsgModal, setMsgModal] = useState(false);
  // const [recordpage, setRecordPage] = useState(5);
  const [isLoader, setLoader] = useState(false);
  const [downloadStates, setDownloadStates] = useState<any>({});
  const [showModal, setShowModal] = useState(false);
  const [pdfDownloadInProgress, setPdfDownloadInProgress] = useState<DownloadProgress>({});


  const navigate = useNavigate();

  function truncateText(text: string, numWords: any) {
    const words = text.split(" ");
    const truncated = words.slice(0, numWords).join(" ");
    if (words.length > numWords) {
      return truncated.replace(/<[^>]*>/g, "");
    }
    return truncated.replace(/<[^>]*>/g, "");
  }

  const userName = `${props?.userInfo?.firstname} ${props?.userInfo?.lastname}`;
  const handleClick = (description: any, subtext: any) => {
    let suggestionid = "";
    if (description === "Accept") {
      suggestionid = "2";
    } else if (description === "Reject") {
      suggestionid = "3";
    } else if (
      description === "Revise (Minor)" &&
      subtext === "Minor changes"
    ) {
      suggestionid = "8";
    } else if (
      description === "Revise (Major)" &&
      subtext === "Major changes"
    ) {
      suggestionid = "9";
    }

    console.log(`Suggestion ID: ${suggestionid}`);
    setCombinedText(suggestionid);
    setAction(description);
  };

  // const isAcceptModalshowfun = ()=>{
  //     setisAcceptModalshow(true)
  // }
  const handleUpdateReviewerInviteStatus = async (statusCode: string) => {
    try {
      const url = apiUrl.nodeApi.updateWordflowReviewerInviteStatus;
      setLoader(true);
      const payload = { status_code: statusCode };
      const response: any = await invokePostService(
        url,
        payload,
        props.isToken
      );
      if (!response.data.data.isSuccess) {
        throw new Error(response.data.data.Error);
      }
      setLoader(false);
      toastSuccess("Reviewer Invite Status Updated Successfully");
      setConfirmationStatus("");
      setdeclineconfirmationStatus("");
      getJournalTitelList("data");
      refreshTable();
    } catch (error) {
      setLoader(false);
      toastError(`Failed to update Reviewer Invite Status: ${error}`);
    }
  };
  const formatDate = (dateString: any) => {
    const date = new Date(dateString);
    date.setUTCHours(date.getUTCHours() - 5);
    date.setUTCMinutes(date.getUTCMinutes() - 30);
    const day = date.getUTCDate();
    const month = date.getUTCMonth() + 1;
    const year = date.getUTCFullYear();
    let hours = date.getUTCHours();
    const minutes = date.getUTCMinutes();
    const ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12 || 12;
    const formattedTime = `${hours}:${minutes
      .toString()
      .padStart(2, "0")}${ampm}`;
    const formattedDate = `${day}-${month
      .toString()
      .padStart(2, "0")}-${year} ${formattedTime}`;
    return formattedDate;
  };

  const handleHistory = (rowdata: any, isOpen: boolean) => {
    if (isOpen == true) {
      downloadWordArticle(rowdata);
      setOpenHistoryModal(true);
    } else {
      setOpenHistoryModal(false);
    }
  };

  const formatedDate = (dateString: string, journal: string) => {
    const date = new Date(dateString);
    return moment(date).format('DD-MM-YYYY');
  };


  const taskColumns = [
    columnHelper.accessor("serial", {
      header: "S.No",
    }),
    columnHelper.accessor("articlename", {
      header: "Article Id",
    }),
    columnHelper.accessor("articletitle", {
      header: "Article Name",
      cell: (row: Row) => {
        const item = row?.getValue() || "";
        const cleanedItem = item.replace(/<[^>]*>/g, "");
        const truncatedItem = truncateText(cleanedItem, 2);
        const displayItem =
          cleanedItem.length > truncatedItem.length
            ? truncatedItem + "..."
            : truncatedItem;
        return (
          <span className="visible" title={cleanedItem}>
            {displayItem}
          </span>
        );
      },
    }),

    columnHelper.accessor("journal", {
      header: "Journal",
      cell: (row: Row) => {
        const item = row?.getValue() || "";
        const hoverText = row?.row?.original?.journalname;
        return (
          <span className="visible" title={hoverText}>
            {item}
          </span>
        );
      },
    }),
    columnHelper.accessor("created_date", {
      header: "Due Date",
      cell: (row: Row) => {
        const journalType = row?.row?.original.journal;
                
                // Return dash for CMLR and TAXI journals
                if (journalType === 'CMLR' || journalType === 'TAXI') {
                    return (
                        <span className="visible">-</span>
                    );
                }
        
                const createdDate = row?.row?.original?.created_on;
                const articleDurations: any = {
                    AIAJ: 3, // weeks
                    EFAR: 3, // weeks
                    IJCL: 1, // month
                };
                
                const duration = articleDurations[journalType] || 0;
                let dueDate;
                
                if (duration > 0) {
                  dueDate = createdDate ? moment(createdDate).add(20, 'days') : moment().add(20, 'days');
                } 
                // else {
                //     dueDate = createdDate ? moment(createdDate).add(20, 'days') : moment().add(20, 'days');
                // }
                
                return (
                    <span className="visible">
                        {dueDate ? dueDate.format('DD-MM-YYYY') : 'N/A'}
                    </span>
                );
            },
        }),                
        // columnHelper.accessor("submitted_date", {
        //     header: "Submission Date",
        //     cell: (props: any) => formatedDate(props.getValue(), props.row.original.journal)
        //   }), 
    columnHelper.accessor("stage", {
      header: "Status",
      cell: (row: Row) => {
        const value = row.getValue();
        let className = "cellStyle";
        let displayValue = value;

        // Setting className and displayValue based on the value
        switch (value) {
          case "review completed":
            className += " greenbadge";
            break;
          case "awaiting response from reviewer":
            className += " yellowBadge";
            displayValue = "awaiting response";
            break;
          case "invitation declined":
            className += " failed";
            displayValue = "invitation declined";
            break;
          case "reviewing manuscript":
            className += " yellowBadge";
            displayValue = " reviewing Manuscript";
            break;
          default:
        }

        return <span className={className}>{displayValue}</span>;
      },
    }),
    columnHelper.accessor("action", {
      header: "Action",
      cell: (row: any) => {
        const rowData = row?.row?.original;
        console.log('rowData', rowData)
        
        // Check if rowData exists
        if (!rowData) return null;

        // Determine if iAuthor is enabled (iauthorenable === 0 means disabled)
        const isAuthorEnabled = rowData?.iauthorenable === 0;
        const handlesuggestion = (suggestion_name: any, suggestion_msg: any) => {
          setisModalshow(true);
          setsuggestion(suggestion_name);
          setMessageuggestionContent(suggestion_msg);
        };

        return (
          <div>
            {
            (
                <>
                  <button
                    className="iconBtn"
                    onClick={() => iAuthorDetails(rowData)}
                    disabled={rowData?.articleguid == null}
                    style={{ border: "none", background: "none" }}
                    title="iAuthor"
                  >
                    <span className="ia-btn f-20" title="iAuthor">
                      iA
                    </span>
                  </button>


            <button
              className="iconBtn"
              onClick={() => handlepdf(rowData)}
              disabled={false}
              style={{ border: "none", background: "none" }}
              title="Download PDF"
            >
              {pdfDownloadInProgress[rowData.articleguid] ? (
                                        <div className="loader"></div>
                                    ) : (
                                        <span className="material-icons f-20">picture_as_pdf</span>
                                    )}
            </button>

                  {/* {isAuthorEnabled && (
                    <button
                      className="iconBtn"
                      onClick={() => subMissionDetails(rowData)}
                      title="Resume Manuscript Summary"
                    // disabled={isDisabled} // Disable when access is revoked or invitation declined
                    >
                      <i className="bi bi-play"></i>
                    </button>
                  )} */}

                  <button
                    className="iconBtn"
                    onClick={() => handlesuggestion(rowData?.suggestion_name, rowData?.suggestion_msg)}
                    disabled={!rowData?.suggestion_name}
                    style={{ paddingTop: '3px', border: "none", background: "none" }}
                    title="Suggestions"
                  >
                    <span
                      className="material-icons f-20"
                      title="Suggestions"
                    >
                      forum
                    </span>
                  </button>
                </>
              )
            }
          </div>
        );
      },
    }),
  ];

  const handlepdf = async (item: any) => {
    const rowId = item.articleguid;
    try {
      let url = apiUrl.nodeApi.getPdfForLanguageEditor;
      const payload = {
        activityid: item.iauthoratyid,
        article_guid: item.articleguid,
      };
      setPdfDownloadInProgress((prevState: DownloadProgress) => ({
        ...prevState,
        [rowId]: true,
    }));
      setLoader(true);
      const timer = setTimeout(() => {
                      setLoader(false);
                      toastWarning("Download in progress, Please wait for few Minutes.");
                  }, 2000);
      const response: any = await invokePostService(
        url,
        payload,
        props.isToken
      );
      setLoader(false);
      if (!response.data.isSuccess) throw new Error(response.data.Error);
      if (response.data.isSuccess) {
        const newWindow = window.open(
          response.data.result.downloadUrl,
          "_blank"
        );
        if (
          !newWindow ||
          newWindow.closed ||
          typeof newWindow.closed === "undefined"
        ) {
          toastWarning(
            "Browser blocked pop-ups. Click the pop-up blocker icon in the address bar and choose 'Allow pop-ups for this site'."
          );
        }
      }
      setLoader(false);

            setPdfDownloadInProgress((prevState: DownloadProgress) => ({
                ...prevState,
                [rowId]: false,
            }));
            clearTimeout(timer);
    } catch (error) {
      setLoader(false);
      setPdfDownloadInProgress((prevState: DownloadProgress) => ({
        ...prevState,
        [rowId]: false,
    }));
      toastWarning(
        "The requested PDF is not available yet. Please try again after a few minutes"
      );
    }
  };

  const getSuggestionTitleColor = (title: string) => {
    switch (title) {
      case "Accept":
        return "green";
      case "Reject":
        return "red";
      // case "Revise with minor change":
      //   return "darkblue";
      default:
        return "darkblue";
    }
  };
  const filterTableData = (journalOption: any, authorOption: any) => {
    const journalValue = journalOption.value
      ? journalOption.value.toLowerCase()
      : "";
    const authorValue = authorOption.value
      ? authorOption.value.toLowerCase()
      : "";
    let filteredData: any;

    if (journalValue !== "all status" && authorValue !== "currently with all") {
      filteredData = initialData.filter(
        (list: any) =>
          list.stage.toLowerCase() === journalValue &&
          list.currentlywith.toLowerCase() === authorValue
      );
    } else if (journalValue !== "all status") {
      filteredData = initialData.filter(
        (list: any) => list.stage.toLowerCase() === journalValue
      );
    } else if (authorValue !== "currently with all") {
      filteredData = initialData.filter(
        (list: any) => list.currentlywith.toLowerCase() === authorValue
      );
    } else {
      filteredData = initialData;
    }

    if (filteredData) {
      const updatedData = filteredData.map((list: any, i: any) => {
        return { ...list, serial: i + 1 };
      });
      setselectfileterData(updatedData);
      setTableData(updatedData);
    }
  };

  useEffect(() => {
    getJournalTitelList("table_list");
    getStagesList("stages");
    getUserRole("roles");
  }, []);

  const handleReason = (e: any) => {
    setReason(e.target.value);
  };
  // const getJournalTitelList = async (type: any) => {
  //   try {
  //     setLoader(true);
  //     let url = apiUrl.nodeApi.getSubmitArticleList;
  //     let payload = {
  //       currentlyWith: [],
  //       stageId: [],
  //     };
  //     const response: any = await invokePostService(
  //       url,
  //       payload,
  //       props.isToken
  //     );
  //     setLoader(false);

  //     if (!response.data.data.isSuccess)
  //       throw new Error(response.data.data.Error);

  //     // I am Filtering out duplicates based on articleid
  //     const uniqueResults = response.data.data.result;

  //     // Adding the serial numbers
  //     uniqueResults.forEach((list: any, i: any) => {
  //       list.serial = i + 1;
  //     });
  //     let filteredResults;
  //     if (props.cusConfig.reviewer.isWordFlow) {
  //       filteredResults = uniqueResults.filter((item: any) => item.iswordflow);
  //     } else {
  //       filteredResults = uniqueResults;
  //     }
  //     // console.log(uniqueResults);
  //     setTableData(filteredResults);
  //     setInitialData(filteredResults);
  //   } catch (error) {
  //     toastError(`Get Article List ${error}`);
  //     setLoader(false);
  //   }
  // };

  const getJournalTitelList = async (type: any) => {
    try {
      setLoader(true);
      let url = apiUrl.nodeApi.getSubmitArticleList;
      let payload = {
        currentlyWith: [],
        stageId: [],
      };
      const response: any = await invokePostService(
        url,
        payload,
        props.isToken
      );
      setLoader(false);
  
      if (!response.data.data.isSuccess)
        throw new Error(response.data.data.Error);
  
      // Adding the serial numbers
      const uniqueResults = response.data.data.result;
      uniqueResults.forEach((list: any, i: any) => {
        list.serial = i + 1;
      });
      
      // Since iswordflow is not in the response, we'll use other criteria
      // or simply use all results if props.cusConfig.reviewer.isWordFlow is true
      let filteredResults;
      // if (props.cusConfig.reviewer.isWordFlow) {
        // Since there's no iswordflow property, we'll use all results
        // or filter based on other criteria like stage or journal
        filteredResults = uniqueResults;
      // } else {
      //   filteredResults = uniqueResults;
      // }
      
      setTableData(filteredResults);
      setInitialData(filteredResults);
    } catch (error) {
      toastError(`Get Article List ${error}`);
      setLoader(false);
    }
  };

  const getUserRole = async (type: any) => {
    try {
      let url = apiUrl.nodeApi.getUserRoles;
      // const response = await axios.get(`${config.prapp.basURL}${url}`);
      const response: any = await invokeGetService(url, {}, {}, props.isToken);
      if (!response.data.data.isSuccess)
        throw new Error(response.data.data.Error);
      response.data.data.result.unshift({
        label: "All Users",
        value: "Currently with All",
        id: "0",
      });
      setCurrentlyDropdown(response.data.data.result);
    } catch (error) {}
  };

  const getStagesList = async (type: any) => {
    try {
      let url = apiUrl.nodeApi.getReviewerStages;
      let payload = {
        userid: props?.userInfo?.userid,
      };
      const response: any = await invokePostService(
        url,
        payload,
        props.isToken
      );
  
      if (!response.data.data.isSuccess)
        throw new Error(response.data.data.Error);
  
      const filtered = response.data.data.result.filter(
        (item: any) => item.id === 1 || item.id === 3
      );
  
      filtered.unshift({
        label: "All Status",
        value: "All Status",
        id: "0",
      });
  
      setStageDropdown(filtered);
    } catch (error) {
    }
  };

  const handleSearch = (e: any) => {
    setContentId(0);
    // setStatusValue('All Status');
    let data: any = "";
    const searchTerm = e.target.value.toLowerCase();
    if (searchTerm.length === 0) {
      if (selectfileterData.length > 0) {
        // setTableData(initialData)
        data = selectfileterData;
        setRender(!render);
      } else {
        if (
          stageValue.label == "All Status" &&
          currentlywithValue.label == "All Users"
        ) {
          data = initialData;
        } else {
          data = [];
        }
        setRender(!render);
      }
    } else {
      if (selectfileterData.length > 0) {
        const filteredData = selectfileterData.filter((row: any) => {
          return Object.values(row).some(
            (value: any) =>
              value &&
              value.toString().toLowerCase().includes(searchTerm.toLowerCase())
          );
        });
        // setTableData(filteredData);
        data = filteredData;
      } else {
        if (
          stageValue.label == "All Status" &&
          currentlywithValue.label == "All Users"
        ) {
          const filteredData = initialData.filter((row: any) => {
            return Object.values(row).some(
              (value: any) =>
                value &&
                value
                  .toString()
                  .toLowerCase()
                  .includes(searchTerm.toLowerCase())
            );
          });
          data = filteredData;
        } else {
          data = [];
        }
      }
    }

    if (data.length) {
      data.map((list: any, i: any) => {
        list.serial = i + 1;
      });
    }
    setTableData(data);
    setSearchData(searchTerm);
  };

  const handleMultiSelection = (e: any, type: any) => {
    if (e.value !== " ") {
      let updatedJournalValue = stageValue;
      let updatedAuthorValue = currentlywithValue;

      if (type === "stage") {
        updatedJournalValue = {
          label: e.label,
          value: e.value,
        };
      } else {
        updatedAuthorValue = {
          label: e.label,
          value: e.value,
        };
      }

      // Update the state values
      setStageValue(updatedJournalValue);
      setCurrentlyValue(updatedAuthorValue);

      // Pass the updated values directly to filterTableData
      filterTableData(updatedJournalValue, updatedAuthorValue);
    }
  };
  // const iAuthorDetails = async (item: any) => {
  //   try {
  //     let url = apiUrl.nodeApi.getReviewerLink;
  //     const payload = {
  //       userId: item?.userid,
  //       articleGuid: item?.reviewerarticleguid,
  //     };
  //     setLoader(true);
  //     const response: any = await invokePostService(
  //       url,
  //       payload,
  //       props.isToken
  //     );
  //     setLoader(false);

  //     if (!response.data.data.isSuccess)
  //       throw new Error(response.data.data.Error);
  //     if (response.data.data.isSuccess) {
  //       const newWindow = window.open(response.data.data.result, "_blank");
  //       if (
  //         !newWindow ||
  //         newWindow.closed ||
  //         typeof newWindow.closed === "undefined"
  //       ) {
  //         toastWarning(
  //           "Browser blocked pop-ups. Click the pop-up blocker icon in the address bar and choose 'Allow pop-ups for this site'."
  //         );
  //       }
  //     }
  //   } catch (error: any) {
  //     setLoader(false);

  //     if (error.message === "[object Object]") {
  //       getJournalTitelList("table_list");
  //       toastSuccess("Status updated successfully! Click again to proceed");
  //     } else {
  //       toastError(`${error}`);
  //     }
  //   }
  // };

  const iAuthorDetails = async (item: any) => {
    try {
      let url = apiUrl.nodeApi.getLinkByGuid;
      const payload = {
        ActivityId: item.iauthoratyid,
        articleId: item.articleid,
        JobID: item.articleguid,
      };
      setLoader(true);
      const response: any = await invokePostService(
        url,
        payload,
        props.isToken
      );
      setLoader(false);
      if (!response.data.isSuccess) throw new Error(response.data.Error);
      if (response.data.isSuccess) {
        const newWindow = window.open(response.data.result, "_blank");
        if (
          !newWindow ||
          newWindow.closed ||
          typeof newWindow.closed === "undefined"
        ) {
          toastWarning(
            "Browser blocked pop-ups. Click the pop-up blocker icon in the address bar and choose 'Allow pop-ups for this site'."
          );
        }
      }
    } catch (error: any) {
      setLoader(false);
      if (error.message === '[object Object]') {
        getJournalTitelList("table_list");
        toastSuccess("Status updated successfully! Click again to proceed");
      } else {
        toastError(`${error}`);
      }
  
    }
  };
  const clickDownload = () => {
    if (downloadData) {
      const newWindow = window.open(downloadData, "_blank");
      if (
        !newWindow ||
        newWindow.closed ||
        typeof newWindow.closed === "undefined"
      ) {
        toastWarning(
          "Browser blocked pop-ups. Click the pop-up blocker icon in the address bar and choose 'Allow pop-ups for this site'."
        );
      }
    }
  };
  const downloadWordArticle = async (item: any) => {
    try {
      let url = apiUrl.nodeApi.getWordFileHistroy;
      const payload = {
        articleid: item?.articleid,
        userid: item?.userid,
        roleid: 3,
        articleguid: item?.reviewerarticleguid,
      };
      console.log(payload, "werweui");
      setLoader(true);
      const response: any = await invokePostService(
        url,
        payload,
        props.isToken
      );
      setLoader(false);
      if (!response.data.data.isSuccess)
        throw new Error(response.data.data.Error);
      if (response.data.data.isSuccess) {
        setWordDownloadData(response.data.data.result);
      }
    } catch (error: any) {
      setLoader(false);

      if (error.message === "[object Object]") {
        getJournalTitelList("table_list");
        toastSuccess("Status updated successfully! Click again to proceed");
      } else {
        toastError(`${error}`);
      }
    }
  };

  const downloadArticle = async (item: any) => {
    try {
      let url = apiUrl.nodeApi.getWordArticleReportDownloadDetail;
      interface Payload {
        articleid: any;
        articleguid?: any;
        isWordFlow?: boolean;
        userid?: any;
        isLanguage?: boolean;
      }
      const payload: Payload = {
        articleid: item?.articleid,
        isWordFlow: true,
        isLanguage: true,
      };
      setLoader(true);
      const response: any = await invokePostService(
        url,
        payload,
        props.isToken
      );

      if (!response.data.data.isSuccess)
        throw new Error(response.data.data.Error);

      // Save download history
      const saveUrl = apiUrl.nodeApi.saveLanguageEditorDownloadHistory;
      const updatePayload = {
        articleid: item?.articleid
      };

      await invokePostService(saveUrl, updatePayload, props.isToken);

      if (response.data.data.isSuccess) {
        // Update download states
        setDownloadStates((prevState: any) => ({
          ...prevState,
          [item.unique_id]: true,
        }));

        // Open download in new window
        const newWindow = window.open(
          response.data.data.result.downloadUrl,
          "_blank"
        );
        if (
          !newWindow ||
          newWindow.closed ||
          typeof newWindow.closed === "undefined"
        ) {
          toastWarning(
            "Browser blocked pop-ups. Click the pop-up blocker icon in the address bar and choose 'Allow pop-ups for this site'."
          );
        }
        // Refresh table data immediately after successful download
        await getJournalTitelList("table_list");
      }
    } catch (error: any) {
      setLoader(false);
      if (error.message === "[object Object]") {
        getJournalTitelList("table_list");
        toastSuccess("Status updated successfully! Click again to proceed");
      } else {
        toastError(`${error}`);
      }
    } finally {
      setLoader(false);
    }
  };

  const downloadwordfile = async (item: any) => {
    try {
      let url = apiUrl.nodeApi.downloadWordFileHistroy;
      const payload = {
        filedata: item?.iauthor_link ? item?.iauthor_link : item?.filepath,
        userid: item?.userid,
        roleid: 3,
      };
      console.log(payload, "werweui");
      setLoader(true);
      const response: any = await invokePostService(
        url,
        payload,
        props.isToken
      );
      setLoader(false);
      if (!response.data.data.isSuccess)
        throw new Error(response.data.data.Error);
      if (response.data.data.isSuccess) {
        const newWindow = window.open(
          response.data.data.result.downloadUrl,
          "_blank"
        );
        if (
          !newWindow ||
          newWindow.closed ||
          typeof newWindow.closed === "undefined"
        ) {
          toastWarning(
            "Browser blocked pop-ups. Click the pop-up blocker icon in the address bar and choose 'Allow pop-ups for this site'."
          );
        }
      }
    } catch (error: any) {
      setLoader(false);
      if (error.message === "[object Object]") {
        getJournalTitelList("table_list");
        toastSuccess("Status updated successfully! Click again to proceed");
      } else {
        toastError(`${error}`);
      }
    }
  };
  const subMissionDetails = async (item: any) => {
    props.dispatchStepAction("1");
    let fileUploaddata = {
      journalid: item.journalid,
      articletype: 0,
      filename: item.articlename,
      articleid: item.articleid,
      journaltitle: item.journalname,
    };
    props.dispatchFileUpload(fileUploaddata);
    navigate("/createnewarticle", { state: { data: item } });
  };

  const pdfDetails = async (item: any) => {
    try {
      let url = apiUrl.nodeApi.getArticleReportDownloadUrl;
      const queryParams = { articleId: item.articleid };
      setLoader(true);
      const response: any = await invokeGetService(
        url,
        {},
        queryParams,
        props.isToken
      );
      setLoader(false);

      if (!response.data.isSuccess) throw new Error(response.data.Error);

      if (response.data.isSuccess) {
        const newWindow = window.open(
          response.data.result.downloadUrl,
          "_blank"
        );
        if (
          !newWindow ||
          newWindow.closed ||
          typeof newWindow.closed === "undefined"
        ) {
          toastWarning(
            "Browser blocked pop-ups. Click the pop-up blocker icon in the address bar and choose 'Allow pop-ups for this site'."
          );
        }
      }
    } catch (error) {
      toastError(`${error}`);
      setLoader(false);
    }
  };

  const handleModalClose = () => {
    setMsgModal(!isMsgModal);
  };
  const handleMsgSubmit = () => {};
  const handleMessageBox = (e: any, type: any) => {
    setMessageContent(e.target.value);
  };

  const refreshTable = () => {
    setStageValue({
      label: "All Status",
      value: "All Status",
    });
    setCurrentlyValue({
      label: "All Users",
      value: "Currently with All",
    });

    getJournalTitelList("stages");
  };
  const addFileUpload = () => {
    props.dispatchStepAction("0");
    navigate("/createnewarticle");
  };

  const handleConfirmationModalClose = () => setisAcceptModalshow(false);
  const handleModalOpen = (status: any) => {
    setConfirmationStatus(status);
    setisAcceptModalshow(true);
  };

  const handleConfirmation = () => {
    handleUpdateReviewerInviteStatus(confirmationStatus);
    handleConfirmationModalClose();
  };

  const handleDeclineConfirmationModalClose = () =>
    setisDeclineModalshow(false);
  const handleDeclineModalOpen = (status: any) => {
    setdeclineconfirmationStatus(status);
    setisDeclineModalshow(true);
  };
  const handleDeclineConfirmation = () => {
    handleUpdateReviewerInviteStatus(declineconfirmationStatus);
    handleDeclineConfirmationModalClose();
  };

  const handleRecommendModal = (rowdata: any) => {
    setArticlerowdata(rowdata);
    setRowData(rowdata);
    console.log(rowdata, "rowdata");
    setOpenRecommendModal(!openRecommendModal);
  };

  const validateFields = async (file: any) => {
    const maxFileSize = 50 * 1024 * 1024; // 50 MB in bytes
    const fileSize = file.size;
    const fileName = file.name;

    const formatFileSize = (size: number) => {
      if (size >= 1024 * 1024) {
        return (size / (1024 * 1024)).toFixed(2) + " MB";
      } else if (size >= 1024) {
        return (size / 1024).toFixed(2) + " KB";
      } else {
        return size + " bytes";
      }
    };

    if (fileSize > maxFileSize) {
      setExtention(
        `File size exceeds the maximum allowed size (50 MB). Your file size: ${formatFileSize(
          fileSize
        )}`
      );
      return false;
    }

    if (fileSize <= 0) {
      setExtention(`${fileName}'s size is 0 KB. Please choose a valid file.`);
      return false;
    }

    return true;
  };

  const checkFileCorruption = async (files: any) => {
    const reader = new FileReader();
    // Read a portion of the file (e.g., the first 100 bytes)
    const chunkSize = 100;
    const blob = files[0].slice(0, chunkSize);
    reader.readAsArrayBuffer(blob);
    reader.onload = () => {
      // File read successfully, no corruption detected
      return true;
    };
    reader.onerror = () => {
      // Error occurred during file reading, indicating possible corruption
      setExtention("File is corrupted or cannot be read.");
      return false;
    };
    return true;
  };

  const resetModalStates = () => {
    setOpenRecommendModal(false);
    setAction("");
    setReason("");
    setFileData("");
    setFileName("");
    setCombinedText("");
    setExtention(""); 
    setFilesize("");
    setRowData("");
  };

  const uploadFile = async (e: any, type: any, key: any) => {
    setLoader(true); // Show loader when starting file upload
    try {
      let filename = e && e.target.files[0] && e.target.files[0].name;
      let file = e && e.target.files[0];
      let filesize = file && file.size;
      const manuscriptName = filename.split('.')[0];

      setFilesize(filesize); // Set filesize state for display or further validation
    // Check if filename matches the article ID
    if (manuscriptName !== articlerowdata?.articlename) {
      setExtention("File name must match the Article ID");
      setFileName("");
      setFileData("");
      return;
    }
      // Check if a file is selected
      if (!file) {
        toastError("No file selected");
        return;
      }

      // Validate file size
      if (filesize <= 0) {
        toastError("File size should be greater than 0 KB");
        return;
      }

      if (filesize > 50 * 1024 * 1024) {
        toastError("File size should not exceed 50 MB");
        return;
      }

      // Additional validation if needed (validateFields and checkFileCorruption)
      if (await validateFields(e)) {
        if (await checkFileCorruption(e.target.files)) {
          // If all checks pass, set file details states
          setExtention(""); // Clear any previous extension error
          setFileName(filename); // Set the filename state
          setFileData(e.target.files[0]); // Set the file data state
        } else {
          toastError("File is corrupted or invalid.");
        }
      } else {
        toastError("Validation failed. Please check your inputs.");
      }
    } catch (error) {
      console.error("Error uploading file:", error);
      toastError("An error occurred while uploading the file.");
    } finally {
      setLoader(false); // Hide loader in all cases (success or failure)
    }
  };
  const removeFile = () => {
    setFileName("");
    setFileData("");
  };
  const handleOptionChange = (event: any) => {
    setSelectedOption(event.target.value);
  };

  const uploadWordArticle = async () => {
    return new Promise(async (resolve, reject) => {
      const formData = new FormData();
      let autoName = Math.floor(Math.random() * 900000) + 100000;
      let stageid: any = 6;
      formData.append("files", fileData);
      formData.append("filename", `${autoName}_manuscript`);
      formData.append("filesize", filesize);
      formData.append("userid", props?.userInfo?.userid);
      formData.append("journalid", articlerowdata?.journalid);
      formData.append("articleid", articlerowdata?.articleid);
      formData.append("inviteid", articlerowdata?.inviteid);
      formData.append("stageid", stageid);

      try {
        let url = apiUrl.nodeApi.insertLanguageEditorUpload;
        const response = await axios.post(
          `${config.prapp.basURL}${url}`,
          formData,
          {
            headers: {
              authorization: `Bearer ${props.isToken}`,
              "Content-Type": "multipart/form-data",
            },
          }
        );
        // const response :any = await invokePostService(url,formData)
        if (!response.data.data.isSuccess) {
          throw new Error(response.data.data.Error);
        }
        setRowData("");
        getJournalTitelList("type");
        resolve(response.data.data.result);
      } catch (error) {
        reject(error);
      }
    });
  };

  const handleSubmit = async () => {
    try {
      uploadWordArticle();
      let payload = {
        suggestionid: 2,
        iscompleted: true,
        articleid: articlerowdata?.articleid,
        userId: props?.userInfo?.userid,
        suggestion: reason,
      };
      let url = apiUrl.nodeApi.updateLanguageEditorAction;
      const response: any = await invokePostService(
        url,
        payload,
        props.isToken
      );
      console.log(response, "response");
      if (!response.data.data.isSuccess) {
        console.log(response.data.data, "response.data.data");
        throw new Error(response.data.data.Error);
      }
      // setShowModal(true)
      toastSuccess(`Reviewer File Submitted Successfully`);
      setOpenRecommendModal(false); // Close modal on success
      getJournalTitelList("type");
      setAction("");
      setReason(""); // Clear reason field
      setFileData(""); // Clear file data
      setFileName(""); // Clear filename
      setCombinedText(""); // Clear suggestion
    } catch (err) {
      console.log(err, "error");
    }
  };

  const handleSubmitReview = async (data: {
    scholarlyMerit: string;
    strengthsWeaknesses: string;
    originality: string;
    contribution: string;
    recommendation: string;
  }) => {
    console.log('Review Data:', data, props, articleDetails);
    const payload = {
      articleid: articleDetails?.articleid,
      userid: articleDetails?.userid,
      articleguid: articleDetails.reviewerarticleguid,
      data: JSON.stringify(data),
    };
    let url = apiUrl.nodeApi.insertReviewerReport;
      const response: any = await invokePostService(
        url,
        payload,
        props.isToken
      );
      if (!response.data.data.isSuccess) {
        console.log(response.data.data, "response.data.data");
        throw new Error(response.data.data.Error);
      }
      setShowModal(false)
    
    // Handle the form submission logic here
  };

  return (
    <>
      {isLoader && <WHSLoader></WHSLoader>}

      <Modal
        show={openRecommendModal}
        onHide={resetModalStates}
        backdrop={"static"}
        style={{ height: "auto" }}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Provide your recommendation</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ maxHeight: "450px", overflowY: "auto" }}>
          <div className="row">
            <div className="col-md-8 col-lg-8 form-group">
              <label>
                Attachment <span className="error">*</span>
                <span
                  className="material-icons file-note cursor-pointer"
                  onClick={() => setFileTipShow(!fileTipShow)}
                >
                  info
                </span>
              </label>
              {fileTipShow ? (
                <div className="file-tip">
                  <p>
                    The file accepted is only .docx. The maximum size limit for
                    the file is 50 MB.
                  </p>
                </div>
              ) : null}
              <div className="file-upload">
                <p>Upload file</p>
                <input
                  type="file"
                  multiple
                  placeholder="Upload"
                  accept=".docx"
                  onChange={(e: any) => {
                    uploadFile(e, "file", true);
                  }}
                  ref={fileInputRef}
                />

                <div className="browser-text">
                  <span className="material-icons">upload</span> Browse
                </div>
              </div>
              {/* {isNext && !fileData ? (
                <span className="error">Upload File is required</span>
              ) : null} */}
              {fileerror ? <span className="error">{fileerror}</span> : null}
            </div>
          </div>

          {fileName ? (
            <div className="row">
              <div className="col-md-8 col-lg-8 form-group">
                <div className="file-upload-container">
                  <div className="icon-container">
                    <button
                      className="iconBtn"
                      style={{ border: "none", background: "none" }}
                      title="iAuthor"
                    >
                      <img
                        src={wordImg}
                        alt="iAuthor"
                        className="word-btn"
                        title="Document download"
                      />
                    </button>
                  </div>
                  <div className="details-container">
                    <div className="file-name">
                      <span>{fileName}</span>
                    </div>
                    <div className="user-details">
                      <span>{userName}</span>
                    </div>
                  </div>
                  <div className="remove-section">
                    <span
                      className="material-symbols-outlined"
                      onClick={() => removeFile()}
                    >
                      cancel
                    </span>
                  </div>
                </div>
              </div>
            </div>
          ) : null}

          {/* <div>
            <div className="icons-container">
              {iconsData.map((iconData, index) => (
                <div
                  className="icon-wrapper"
                  onClick={() =>
                    handleClick(iconData.description, iconData.subtext)
                  }
                  style={
                    action === iconData.description
                      ? { border: "1px solid #44a147" }
                      : undefined
                  }
                  key={index}
                >
                  <img
                    className="icon-image"
                    src={iconData.icon}
                    alt={`Icon ${index + 1}`}
                  />
                  <div className={`description ${iconData.type}`}>
                    {iconData.description.split(" ")[0]}
                  </div>
                  {iconData.subtext && (
                    <div className="subtext">{iconData.subtext}</div>
                  )}
                </div>
              ))}
            </div>
            <p className="reason">
              please support your recommendation with comments suitable for
              transmission to the author
            </p>
          </div> */}

          <div>
            <label className="reason-lable">
              Reason <span className="error">*</span>
            </label>

            <WMSTextArea
              placeHolder="Enter your reason..."
              className="form-control textareawidth mt-2 smaller"
              rows={5}
              value={reason}
              onChange={(e: any) => handleReason(e)}
              id="reason"
            />

            <p className="reason-error">
              <span
                style={{ verticalAlign: "bottom" }}
                className="material-symbols-outlined"
              >
                info
              </span>
              <span style={{ paddingLeft: "5px" }}>
                Maximum charactor length is 1000
              </span>
            </p>
          </div>
        </Modal.Body>
        <Modal.Footer className="messageBox d-flex">
          <Button
            onClick={() => handleSubmit()}
            disabled={!fileData || !reason.trim()}
          >
            Submit
          </Button>
          {/* <Button
            onClick={() => setShowModal(true)}
            // disabled={!fileData || !action || !reason.trim()}
          >
            open Popup
          </Button> */}
          <Button
            className="ml-3"
            variant="outline-secondary"
            onClick={resetModalStates}
          >
            CANCEL
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal
        show={isAcceptModalshow}
        centered
        onHide={handleConfirmationModalClose}
      >
        <Modal.Header closeButton>
          <Modal.Title>Confirm Action</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>Are you sure you want to accept this invite?</p>
        </Modal.Body>
        <Modal.Footer className="messageBox d-flex">
          <Button onClick={handleConfirmation}>OK</Button>
          <Button
            className="ml-3"
            variant="outline-secondary"
            onClick={handleConfirmationModalClose}
          >
            Cancel
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal
        show={isDeclineModalshow}
        centered
        onHide={handleDeclineConfirmationModalClose}
      >
        <Modal.Header closeButton>
          <Modal.Title>Confirm Action</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>Are you sure you want to decline this invite?</p>
        </Modal.Body>
        <Modal.Footer className="messageBox d-flex">
          <Button onClick={handleDeclineConfirmation}>OK</Button>
          <Button
            className="ml-3"
            variant="outline-secondary"
            onClick={handleDeclineConfirmationModalClose}
          >
            Cancel
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal
        show={openHistoryModal}
        onHide={() => handleHistory('', false)}
        backdrop={"static"}
        style={{ height: "500px" }}
        centered
      >
        <Modal.Header closeButton>
            <Modal.Title>History</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ height: "400px", overflowY: "auto", position: "relative" }}>
          {wordDownloadData.length ? wordDownloadData.map((item: any) =>
                <>
                  <div className="row" style={{ position: "static" }}>
                        <div className="col-md-12 col-lg-12 form-group">
                        <div className="overall-history-container">
                            <div className="file-upload-container">
                                <div className="icon-container">
                                    <button
                                        className="iconBtn"
                                        style={{ border: "none", background: "none", marginLeft: "-10px" }}
                                        title="iAuthor"
                                    >
                                        <img
                                            src={wordImg}
                                            alt="iAuthor"
                                            className="word-btn"
                                            title="Document download"
                                        />
                                    </button>
                                </div>
                                <div className="details-container">
    <div className="file-name">
        <span>{item.filepath ? item.filepath?.split('/').pop() : item.iauthor_link?.split('/').pop()}</span>
    </div>
    <div className="user-details-fsize">
        <span>  <span className="user-details-color"> Uploaded by</span> {item?.username}</span>
    </div>
    <div className="user-details-fsize">
        <span><span className="user-details-color">Role</span> {item?.role}</span>
    </div>
                                </div>
                                <div className="download-section">
                                    <button
                                        className="iconBtn"
                                        onClick={() => downloadwordfile(item)}
                                        style={{ border: "none", background: "none" }}
                                        title="Upload"
                                    >
                                        <span className="material-symbols-outlined f-20">download</span>
                                    </button>
                                </div>
                                {/* <span> {formatDate(item.createdon)} </span> */}
                            </div>
                            <div className="creation-date">
        {formatDate(item.createdon)}
    </div>
                        </div>
                        </div>
                    </div>
                </>
              ) : <p style={{ marginTop: "20px" }}>No article history found!</p>
            }

        </Modal.Body>
      </Modal>
      <Modal show={isMsgModal} centered onHide={handleModalClose}>
        <Modal.Header closeButton>
          <Modal.Title>Send Message</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="row">
            <div className="col-12 form-group">
              <label className="col-form-label">
                Message <span className="error"> *</span>
              </label>
              <textarea
                maxLength={1000}
                placeholder={"Write message"}
                value={message}
                name="comments"
                className="form-control"
                onChange={(e: any) => handleMessageBox(e, "reason")}
                id="comments"
              />
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer className="messageBox d-flex">
          <Button onClick={handleMsgSubmit}>SAVE</Button>
          <Button
            className="ml-3"
            variant="outline-secondary"
            onClick={handleModalClose}
          >
            CANCEL
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={isModalshow}
        centered
        onHide={() => {
          setisModalshow(false);
        }}
      >
        <Modal.Header closeButton>
          <Modal.Title style={{ fontWeight: "bolder" }}>Comments</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div
            className="row"
            style={{ textAlign: "start", paddingLeft: "20px" }}
          >
            <p className="pt-15">
              <p className=" d-flex gap-10">
                Status
                <span
                  className="cellStyle"
                  style={{
                    color: getSuggestionTitleColor(suggestion),
                    backgroundColor: "rgb(244, 245, 250)",
                    marginTop: "-5px",
                  }}
                >
                  {suggestion}
                </span>
              </p>
              <div
                style={{
                  backgroundColor: "#f4f5fa",
                  marginRight: "20px",
                  borderRadius: "10px",
                  width: "400px",
                }}
              >
                <p style={{ padding: "20px" }}>{messageuggestion}</p>
              </div>
            </p>
          </div>
        </Modal.Body>
      </Modal>

      <div className="page-title">
        <h3>Manuscript Summary</h3>
      </div>
      <div className="mb-5">
        <div className="table-filter">
          <div className="row justify-content-between">
            <div className="col-lg-4 search-input">
              <WMSInput
                type="text"
                placeHolder="Search by Article ID, Article Title and Journal..."
                className="form-control"
                value={searchData}
                onChange={(e: any) => handleSearch(e)}
                id="search-table"
              />
              <span className="material-icons">search</span>
            </div>
            <div className="d-flex col-lg-8 table-dropdown-filter">
              <div className="d-flex">
                <label>Filter by</label>
                <div className="table-dropdown-filter-inner">
                  <WMSSelect
                    className="form-control"
                    placeHolder="Select..."
                    options={stageDropdown}
                    name="fileTypes"
                    value={stageValue}
                    isMulti={false}
                    onChange={(e: any) => handleMultiSelection(e, "stage")}
                    id="fileTypes"
                  />
                  <Button
                    className="btn btn-primary refresh-btn"
                    onClick={() => refreshTable()}
                  >
                    <span className="material-icons">refresh</span>
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div>
          {isTableLoader ? (
            <TableLineLoader />
          ) : (
            <>
              {/* <WMSSimpleTable
                isTableLoader={isTableLoader}
                columns={columns}
                tableData={tableData}
                isPagination={true}
                pageValue={pagination}
                recordPerpage={recordpage}
                iAuthorDetails={(item: any) => iAuthorDetails(item)} //this is for iauthor link button
                pdfDetails={(item: any) => pdfDetails(item)} //this is for pdf details
                subMissionDetails={(item: any) => subMissionDetails(item)} // this is for submission detail popup
              /> */}
              <CustomTable
                columns={taskColumns}
                data={tableData}
                showPagination={true}
                isSearchable={false}
              />
            </>
          )}
        </div>
      </div>
    </>
  );
}
const mapStateToProps = (state: any) => {
  return {
    isLogged: state.rootReducer.authReducer.isLoggedIn,
    isToken: state.rootReducer.authReducer.token,
    userInfo: state.rootReducer.authReducer.userInfo,
    cusConfig: state.rootReducer.customerConfigReducer.cusConfig,
  };
};
const mapDispatchToProps = (dispatch: any) => {
  return {
    dispatchStepAction: (stepCounter: any) => {
      dispatchStepAction(dispatch, stepCounter);
    },
    dispatchFileUpload: (fileUploaddata: any) => {
      dispatchFileUpload(dispatch, fileUploaddata);
    },
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(HOCAutoLogout(LangEDManuscript));